import { Module } from "vuex";
import { state } from "./state";
import { actions } from "./actions";
import { mutations } from "./mutations";
import { IPracticeState } from "@/store/modules/practice/types";
import { getters } from "@/store/modules/practice/getters";
import { RootState } from "@/store/types";

const namespaced: boolean = true;

export const practiceModule: Module<IPracticeState, RootState> = {
  namespaced,
  state,
  actions,
  mutations,
  getters,
};
